import * as React from "react";
import { CardTitle } from "../../../../components/antd/card/CardTitle";
import { CardContent } from "../../../../components/antd/card/CardContent";
import { formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpDescription } from "../../../gvc/testNewForm/CpDescription";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { CpErrorWarningArrayIcon } from "../../../gvc/testNewForm/CpErrorWarningArrayIcon";

export const ProviderAWS: React.FC = () => {
  const { id } = useCpFormContext();
  const method = useCpFormValue("aws.method");

  return (
    <>
      <CardTitle>
        AWS
        <CpErrorWarningArrayIcon names={["aws"]} />
      </CardTitle>
      <CardContent>
        {method === "roleArn" ? (
          <CpFormItem>
            <CpLabel name={`aws.roleArn`}>AWS Role ARN</CpLabel>
            <CpDescription>
              <span>
                Click{" "}
                <span
                  className="cursor-pointer"
                  style={{ color: "var(--color-blue-400)" }}
                  onClick={() => {
                    formSetValue(id, "aws.method", "accountId");
                    formSetValue(id, "meta.drawer", "provider-aws-role-arn-guide");
                  }}
                >
                  here
                </span>{" "}
                to learn how to create a Role ARN.
              </span>
            </CpDescription>
            <CpInput name={`aws.roleArn`} style={{ maxWidth: 600 }} />
            <CpErrorWarning name={`aws.roleArn`} />
          </CpFormItem>
        ) : (
          <CpFormItem>
            <CpLabel name={`aws.accountId`}>AWS Account ID</CpLabel>
            <CpDescription>
              <div>
                <div>
                  Role ARN can be constructed from the AWS Account ID if you did not know the value for Role ARN and
                  followed the guide above. When a value of Role ARN is provided above, it will be used instead of
                  constructing from Account ID.
                </div>
                <div>
                  Click{" "}
                  <span
                    className="cursor-pointer"
                    style={{ color: "var(--color-blue-400)" }}
                    onClick={() => {
                      formSetValue(id, "meta.drawer", "");
                      formSetValue(id, "aws.method", "roleArn");
                    }}
                  >
                    here
                  </span>{" "}
                  to input a Role ARN instead.
                </div>
              </div>
            </CpDescription>
            <CpInput name={`aws.accountId`} style={{ maxWidth: 600 }} />
            <CpErrorWarning name={`aws.accountId`} />
          </CpFormItem>
        )}
      </CardContent>
    </>
  );
};
